import React, { useContext, useState } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Modal, Button, Form } from 'react-bootstrap';
import { ModalContext } from './contexts/modal';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import HomePage from './pages/Home';
import Vacancies from './pages/Vacancies';
import Vacancy from './pages/Vacancy';
import ContactUs from './pages/ContactUs';
import SignIn from './pages/SignIn/index';
import SignUp from './pages/Signup/index';
import Wallet from './pages/wallet';
import Profile from './pages/profile';
import ResetPassword from './pages/ResetPassword';
import BusinessCategoryDetail from './pages/businessCategoryDetail';
import Forms from './pages/Home/Forms';
import { trackPromise } from 'react-promise-tracker';
import ButtonLoader from './components/ButtonLoader';
import ScrollToTop from './components/ScrollToTop';

import { Formik } from 'formik';
import * as Yup from "yup";
import api from "./api";

const Routes = () => {
    const { regModal, handleModalClose, onRegisterClick, showSubmitButton, phoneModal, setPhoneModal } = useContext(ModalContext);
    const { isCellUpdate, setIsCellUpdate } = useState(false);

    const validSchema = Yup.object().shape({
        cellNumber: Yup.string().required("Required").max(10, 'Phone must contain 11 numbers').min(10, 'Phone must contain 11 numbers')
    });

    const onCellNumberUpdate = async (values) => {
        try {
            const res = await api.patch("/users/user", values);
            setPhoneModal(false);
        } catch (error) {
            console.log('error:', error);
        }
    }

    return (
        <ScrollToTop>
            <NavBar regModal={regModal} onRegisterClick={onRegisterClick} />
            <Switch>
                <Route exact path="/" component={HomePage} />
                <Route exact path="/contact-us" component={ContactUs} />
                <Route exact path="/vacancies" component={Vacancies} />
                <Route exact path="/vacancies/:id" component={Vacancy} />
                <Route exact path="/signin" component={SignIn} />
                <Route exact path="/signup" component={SignUp} />
                <Route exact path="/wallet" component={Wallet} />
                <Route exact path="/profile" component={Profile} />
                <Route exact path="/resetPassword/:resetToken" component={ResetPassword} />
                <Route exact path="/businessCategoryDetail/:id" component={BusinessCategoryDetail} />
                <Redirect to="/" />
            </Switch>
            <Footer />

            <Modal
                show={regModal ? true : false}
                onHide={handleModalClose}
                centered
                size="lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Register as {regModal?.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Forms type={regModal?.key} id="registerForm" onFormSubmit={(values) => console.log(values)} />
                </Modal.Body>
                <Modal.Footer>

                    <Button variant="secondary" onClick={handleModalClose}>
                        Close
                    </Button>
                    {
                        showSubmitButton ? <Button className="button" type="submit" form="registerForm">

                            <ButtonLoader trackerArea="register">
                                Submit
                            </ButtonLoader>
                        </Button> : ""
                    }

                </Modal.Footer>
            </Modal>

            <Modal
                show={phoneModal}
                centered
                size="md"
            >
                <Modal.Header>
                    <Modal.Title>Provide mobile number</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Formik
                        onSubmit={(values) => trackPromise(onCellNumberUpdate(values), 'mobileForm')}
                        validationSchema={validSchema}
                        enableReinitialize
                        initialValues={{
                            cellNumber: '',
                        }}
                    >
                        {(formik) => (
                            <Form
                                onSubmit={formik.handleSubmit}
                                id={'mobileForm'}
                            >
                                <Form.Group controlId="cellNumber" hasValidation>
                                    <Form.Label className="form__label">Cell Number</Form.Label>
                                    <Form.Control
                                        className="p-3 rounded-0"
                                        type="number"
                                        name="cellNumber"
                                        placeholder="03xxxxxxxxx"
                                        value={formik.values.cellNumber}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isValid={formik.touched.cellNumber && !formik.errors.cellNumber}
                                        isInvalid={formik.touched.cellNumber && formik.errors.cellNumber}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.cellNumber}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Form>
                        )}
                    </Formik>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="button" type="submit" form="mobileForm">
                        <ButtonLoader trackerArea="mobileForm">
                            Submit
                        </ButtonLoader>
                    </Button>
                </Modal.Footer>
            </Modal>
        </ScrollToTop >
    )
}

export default Routes;